/**
 * Header JavaScript singleton module
 */

var Header = (function($) {

  function initHeader() {
    // do something
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.header').length) {
      return;
    }

    var headerHeight = $('.header').height();
    //$('.main').css({"padding-top": headerHeight });

    if ($('.home .header').length) {

        $(window).scroll(function() {    
            var scroll = $(window).scrollTop();
            
        
            if (scroll >= 100) {
                $(".header").addClass("sticky");
                //$('.main').css("padding-top", "0");
            } else {
                $(".header").removeClass("sticky");
            }

            var headerHeight = $('.header').height();
            //$('.main').css({"padding-top": headerHeight });
            
        });

        $(window).resize(function() {
            var headerHeight = $('.header').height();
            //$('.main').css({"padding-top": headerHeight });
            
        });

      }

    initHeader();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Header.init);
